if (!window.WA)
{
  const noop = function() {};
  const value = '';
  const handler = { addHandler: noop, removeHandler: noop };

  const AdminPanel = {
    ContentAreaUnload: value,
    isDisposed: noop,
    getContentAreaType: noop,
    showNotification: noop,
    hideContentPageShadingContainer: noop,
    hideAllNotification: noop,
    enableButtons: noop,
    AdminPanelReady: handler,
    ContentAreaLoaded: handler,
    ContentAreaUnload: handler,
    VisualStylesChanged: handler,
    ThemeResourcesLoaded: handler,
    VisualStylesChanged: handler,
    Dispose: handler,
    PageModelType: { View: value, Edit: value },
    NotificationType: { Information: value },
    PageModel: { Model: noop, PageModeChanged: handler },
    ZIndex: { EditModeToolBar: { ToolBarEditorTd: value } },
    getPanelResources: function() { return { AccountDomainNames: value } }
  };

  const UI = {
    FileSortType: { SortByDateDes: value }
  };

  const Admin = {
    FeatureToggle: { accessGranted: noop },
    Emails: { EmailEditorMock: noop }
  };

  window.WA = { AdminPanel, UI, Admin };
}